<template>
  <div class="content flex-box vertical">
    <data-list
      ref="dataList"
      class="flex-grow"
      :add-btn="false"
      name="申请"
      hide-audit
      hide-edit
      :url="url"
      :query="query"
      :rules="rules"
      :custom-url="customUrl"
      :before-update="beforeUpdate"
      :action-width="200"
      :modal-width="480"
      :modal-form="modalForm"
      :search-key-type="{name: 1}"
      :columns="columns"
      @detail="showDetail">
      <template v-slot:title="{total}">
        <span>申请列表（共{{total}}条记录）</span>
      </template>
      <template v-slot:query="{form}">
        <a-form-model-item label="">
          <a-input-search v-model="form.keyword" placeholder="输入姓名/手机号码查询" @search="getList"></a-input-search>
        </a-form-model-item>
      </template>
      <template v-slot:edit="{form}">
        <a-form-model-item label="姓名" prop="name">
          <a-input v-model="form.name" placeholder="请输入姓名"></a-input>
        </a-form-model-item>
        <a-form-model-item label="手机号" prop="mobile">
          <a-input v-model="form.mobile" placeholder="请输入手机号"></a-input>
        </a-form-model-item>
      </template>
    </data-list>
  </div>
</template>

<script>

import {getApplyStageText, getApplyStatusText} from "@/common/constant/apply";

    export default {
        name: "ApprovalList",
        data() {
            return {
                url: "/admin/apply",
                query: "&filter[status][gt]=2&sort=-id&expand=user",
                columns: [
                    { title: '提交时间', dataIndex: 'create_time' },
                    { title: '手机号', dataIndex: 'user.mobile' },
                    { title: '会议名称', dataIndex: 'chinese_name' },
                    { title: '会议时间', dataIndex: 'hold_time', customRender: text => text  ? text.split(' ')[0] : "" },
                    { title: '主办单位', dataIndex: 'organizer' },
                    { title: '审批状态', dataIndex: 'status', customRender: getApplyStatusText },
                    { title: '当前阶段', customRender: getApplyStageText },
                ],
                rules: {
                    name: [{required: true, message: '请输入姓名', trigger: 'blur'}],
                    mobile: [
                        {required: true, message: '请输入手机号', trigger: 'blur'},
                        { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
                    ],
                },
                modalForm: {
                    labelAlign: 'left',
                    labelCol: {span: 6},
                    wrapperCol: {span: 18}
                }
            }
        },
        methods: {
            showDetail({item}) {
                this.$router.push({name: "ApprovalDetail", params: {id: item.id}});
            },
            beforeUpdate(form, fn) {
                const data = {...form};
                if(data.type == "password") {
                    delete data.type;
                } else if(!form.id){
                    data.type = 2;
                }
                fn({...data});
            },
            customUrl(url, form) {
                let res = "";
                if(form.keyword) {
                    res += `&filter[or][0][name][like]=${form.keyword}&filter[or][1][mobile][like]=${form.keyword}`;
                }
                return res;
            },
            changePassword(item) {
                const form = {
                    id: item.id,
                    type: "password"
                }
                this.$refs.dataList.showEdit(form);
            },
            getList() {
                this.$refs.dataList.getList();
            },
        }
    }
</script>

<style scoped>

</style>
